export default class BackofficeNotificationsIndex {

  constructor() {
  }

  onDataChanged(data) {
  }

  onDestroy() {
   
  }
}